import MuiSwitch, { SwitchProps } from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import { colorConstants } from 'data/constants';

interface ISwitch extends SwitchProps {
  label?: string;
  switchType?: 'ios' | 'android';
  className?: string;
}

const Switch = styled(MuiSwitch, {
  shouldForwardProp: () => true,
})<ISwitch>(({ switchType, theme }) => {
  if (switchType === 'ios') {
    return {
      width: 42,
      height: 20,
      padding: 0,
      '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 1,
        transitionDuration: '300ms',
        '&.Mui-checked': {
          transform: 'translateX(16px)',
          color: '#fff',
          '& + .MuiSwitch-track': {
            backgroundColor: colorConstants.brandColor,
            opacity: 1,
            border: 0,
          },
          '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.5,
          },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
          color: '#33cf4d',
          border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
          color:
            theme.palette.mode === 'light'
              ? theme.palette.grey[100]
              : theme.palette.grey[600],
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
        },
      },
      '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 20,
      },
      '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: colorConstants.lightGray,
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
          duration: 200,
        }),
      },
    };
  }
});

export default Switch;
